import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { isDevMode } from '@angular/core';

bootstrapApplication(AppComponent, appConfig)
  .then(()=>{
    // if ('serviceWorker' in navigator && !isDevMode()) {
    //   navigator.serviceWorker.register('/bell-service-worker.js')
    //     .then(() => console.log('Bell push notification SW registered'))
    //     .catch(err => console.error('Bell push notification SW registration failed', err));
    // }
  })
  .catch((err) => console.error(err));
